// extracted by mini-css-extract-plugin
module.exports = {"faq-section":"FAQ_faq-section__kBFpB","header":"FAQ_header__GArfh","q-and-a":"FAQ_q-and-a__yHYgs","q-and-a__question":"FAQ_q-and-a__question__kd3Dq"};